module.exports = __webpack_public_path__ + "49cf68678795d3adce057439688162be.pdf";